var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-md-flex h-md-100 align-items-center" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-md-5 p-0 bg-white h-md-100 loginarea" }, [
        _c(
          "div",
          { staticClass: "d-md-flex col-12 align-top" },
          [
            _c("img", {
              staticStyle: { "padding-top": "10px" },
              attrs: {
                src: require("@/resources/img/ktb-logo.png"),
                width: "152",
                height: "56"
              }
            }),
            _c("img", {
              attrs: {
                src: require("@/resources/img/h_elg.jpg"),
                width: "284",
                height: "58"
              }
            }),
            _c("router-link", { attrs: { to: "Login" } }, [
              _c("img", {
                attrs: {
                  src: require("@/resources/img/login.jpg"),
                  width: "59",
                  height: "58"
                }
              })
            ])
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "align-items-center h-md-100 p-5 justify-content-center"
          },
          [
            _vm._m(1),
            _c(
              "form",
              {
                staticClass: "rounded p-5",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.saveContact($event)
                  }
                }
              },
              [
                _vm._m(2),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "have-text",
                      attrs: { for: "usernameLogin" }
                    },
                    [_vm._v("E-Mail")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{required:true}"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      input: true,
                      "is-danger": _vm.errors.has("email")
                    },
                    attrs: {
                      type: "email",
                      required: "",
                      name: "email",
                      placeholder: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _c("span", { staticClass: "highlight" }),
                  _c("span", { staticClass: "bar" }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("email"),
                          expression: "errors.has('email')"
                        }
                      ],
                      staticClass: "help is-danger"
                    },
                    [_vm._v("ระบุ E-Mail")]
                  )
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { staticClass: "have-text", attrs: { for: "telNo" } },
                    [_vm._v("เบอร์โทรศัพท์")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.telNo,
                        expression: "telNo"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|digits:10",
                        expression: "'required|digits:10'"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      input: true,
                      "is-danger": _vm.errors.has("telNo")
                    },
                    attrs: { type: "number", name: "telNo", placeholder: "" },
                    domProps: { value: _vm.telNo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.telNo = $event.target.value
                      }
                    }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("telNo"),
                          expression: "errors.has('telNo')"
                        }
                      ],
                      staticClass: "help is-danger"
                    },
                    [_vm._v("ระบุ เบอร์โทรศัพท์ ต้องเป็นตัวเลข 10 หลัก")]
                  )
                ]),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-round btn-block shadow-sm",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("ตกลง")]
                )
              ]
            )
          ]
        )
      ])
    ]),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-7 p-0 bg-indigo h-md-100 logoarea" },
      [
        _c(
          "div",
          {
            staticClass:
              "text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
          },
          [_c("div", { staticClass: "pt-5 pb-5" })]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "caution" }, [
      _vm._v(
        "\n          ธนาคารได้รับข้อมูลการขอออกหนังสือค้ำประกัน e-LG Blockchain เรียบร้อยแล้ว\n          "
      ),
      _c("br"),
      _vm._v(
        "ทางหน่วยงานอำนวยสินเชื่อ (RM.) จะดำเนินการติดต่อกลับไปยังท่าน\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h6", { staticClass: "mb-0" }, [
        _vm._v("ข้อมูลเพื่อให้ธนาคารกรุงไทยติดต่อกลับ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "ft-content space-up" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 text-left" }, [
            _c("i", { staticClass: "feather-icon icon-phone" }),
            _c("span", [_vm._v("02-111-1111, 02-111-9999 KTB Call Center")])
          ]),
          _c("div", { staticClass: "col-6 text-right" }, [
            _c("span", { staticClass: "text-red" }, [
              _vm._v(
                "การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป"
              )
            ]),
            _c("br"),
            _c("i", { staticClass: "fa fa-copyright" }),
            _c("span", [_vm._v("สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }